<template>
<div>
    <div class="flex flex-col w-full h-auto mb-12">
            <!-- Header -->
            <div :class="desktopClass" class="flex w-full h-auto justify-center items-center">
                <span class="Helvetica text-2xl font-bold text-green-500  justify-center normal-case">{{$t('order_information')}}</span>
            </div>
            <!-- <div :class="desktopClass" class="flex w-full h-auto justify-center items-center">
                <div class="flex  w-full h-auto py-3 justify-end text-sm font-thin px-5">
                    <button @click="OrderChange" class="rounded flex focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300"><i class="material-icons">replay</i> Create change Order</button>
                </div>
            </div> -->

             <!-- NEW: Price Reduction Approval Section -->
            <div v-if="hasPendingPriceReduction()" class="px-6 mb-6">
                <div class="flex w-full justify-between shadow-lg items-start bg-gradient-to-r from-orange-50 to-yellow-50 border-l-4 border-orange-400 h-auto p-6 rounded-lg">
                    <div class="flex w-full mt-1">
                        <span class="rounded-full h-12 w-12 bg-orange-200">
                            <i class="material-icons p-3 text-orange-600">attach_money</i>
                        </span>

                        <div class="ml-5 w-full">
                            <div class="flex justify-between items-center mb-4">
                                <div class="text-lg font-semibold text-orange-800">
                                    🔔 Demande de Réduction de Prix
                                </div>
                                <div class="text-sm text-orange-600 font-medium">
                                    En attente d'approbation
                                </div>
                            </div>

                            <!-- Price Comparison -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                <div class="bg-red-100 border border-red-300 rounded-lg p-3 text-center">
                                    <h4 class="font-semibold text-red-800 text-sm">Prix Original</h4>
                                    <p class="text-xl font-bold text-red-600">
                                        {{ item.priceReduction.originalPrice }} 
                                        <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
                                    </p>
                                </div>
                                <div class="bg-green-100 border border-green-300 rounded-lg p-3 text-center">
                                    <h4 class="font-semibold text-green-800 text-sm">Prix Proposé</h4>
                                    <p class="text-xl font-bold text-green-600">
                                        {{ item.priceReduction.proposedPrice }} 
                                        <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup>
                                    </p>
                                </div>
                                <div class="bg-blue-100 border border-blue-300 rounded-lg p-3 text-center">
                                    <h4 class="font-semibold text-blue-800 text-sm">Économie</h4>
                                    <p class="text-lg font-bold text-blue-600">
                                        {{ (item.priceReduction.originalPrice - item.priceReduction.proposedPrice).toFixed(2) }}
                                    </p>
                                    <p class="text-xs text-blue-600">
                                        ({{ ((item.priceReduction.originalPrice - item.priceReduction.proposedPrice) / item.priceReduction.originalPrice * 100).toFixed(1) }}%)
                                    </p>
                                </div>
                            </div>

                            <!-- Reduction Details -->
                            <div class="space-y-3 mb-4">
                                <div class="bg-white rounded-lg p-3 border border-gray-200">
                                    <h5 class="font-semibold text-gray-800 text-sm mb-2">Raison de la réduction:</h5>
                                    <p class="text-gray-700 text-sm">{{ item.priceReduction.reductionReason }}</p>
                                </div>

                                <div class="flex justify-between text-sm text-gray-600">
                                    <span>
                                        <strong>Demandé par:</strong> 
                                        {{ item.priceReduction.teleConsultantName || 'Télé-conseiller' }}
                                    </span>
                                    <span>
                                        <strong>Le:</strong> 
                                        {{ $moment(item.priceReduction.proposedAt).format('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </div>
                            </div>

                            <!-- Admin Response Section -->
                            <div class="border-t border-gray-200 pt-4">
                                <!-- <h5 class="font-semibold text-gray-800 mb-3">Réponse Administrateur</h5> -->
                                
                                <!-- Response Comment -->
                                <div class="mb-4">
                                    <label class="block text-sm font-medium text-gray-700 mb-2">
                                        Commentaire (optionnel)
                                    </label>
                                    <textarea
                                        v-model="priceReductionResponse.comment"
                                        rows="3"
                                        placeholder="Commentaire sur votre décision..."
                                        class="w-full border border-gray-400 p-2 rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm"
                                    ></textarea>
                                </div>

                                <!-- Action Buttons -->
                                <div class="flex space-x-3">
                                    <button
                                        @click="approvePriceReduction"x
                                        :disabled="processingPriceReduction"
                                        class="flex-1 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200 disabled:opacity-50"
                                    >
                                        <span v-if="processingPriceReduction" class="flex items-center justify-center">
                                            <svg class="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Traitement...
                                        </span>
                                        <span v-else>✅ Approuver la Réduction</span>
                                    </button>

                                    <button
                                        @click="rejectPriceReduction"
                                        :disabled="processingPriceReduction"
                                        class="flex-1 bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200 disabled:opacity-50"
                                    >
                                        <span v-if="processingPriceReduction" class="flex items-center justify-center">
                                            <svg class="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Traitement...
                                        </span>
                                        <span v-else>❌ Refuser la Réduction</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ******************************** -->
            <div class="" :class="!desktopClass ? 'px-6' : ''">
                <div :id="'order-'+item._id">
                    <div :class="!desktopClass ? 'p-6 my-1 mt-5' : 'px-4'" v-if="item.status && item.status.name=='Confirmed' && currentUser.type!='Seller'" class="flex w-full justify-between shadow-xs items-center h-auto mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span :class="desktopClass" class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-green-400 ">local_shipping</i>
                            </span>

                            <div class="w-full" :class="!desktopClass ? 'ml-5 pb-4' : ''">
                                <div :class="!desktopClass ? 'pb-10 mt-1' : 'pb-5'" class="text-base font-semibold text-gray-600">{{$t('shipping')}}</div>
                                <div class="grid grid-rows-2 grid-flow-col gap-4">
                                    <div class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                            <p>
                                                <label for="customerAddress" class="bg-white text-gray-700 px-1" >{{$t('address_shipping')}}<span :class="$colors.required">*</span></label>
                                            </p>
                                            </div>
                                            <p>
                                            <textarea id="customerAddress" type="text" v-model="shipping.address" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed' ? true :false"
                                                class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                            </p>
                                    </div>
                                    
                                    <!-- <div>
                                        <div v-if="sous_warehouses_orders.length>0" class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                            <p>
                                                <label for="customerAddress" class="bg-white text-gray-700 px-1" >Ville de stockage<span :class="$colors.required">*</span></label>
                                            </p>
                                            </div>
                                            <p>
                                                <v-select  v-model="item.zone" :options="sous_warehouses_orders" label="name"></v-select>
                                            </p>
                                        </div>
                                       
                                    </div> -->

                                    <!-- <div>
                                        <div  class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                            <p>
                                                <label for="customerAddress" class="bg-white text-gray-700 px-1" >Zone<span :class="$colors.required">*</span></label>
                                            </p>
                                            </div>
                                            <p>
                                                <v-select  v-model="item.zone" disabled :options="zones" label="name"></v-select>
                                            </p>
                                        </div>
                                       
                                    </div> -->
                                
                                        <div  class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                <label for="category" class="bg-white text-gray-700 px-1">Shipping date <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            
                                            <p>
                                                <datetime-v2 type="datetime" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed' ? true :false" v-model="shipping.date" :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')"
                                            placeholder="Shipping date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                                            </p>
                                            <input type="hidden" name="order" v-model="shipping.order">
                                        </div>
                                        
                                    
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex bg-white w-full space-x-2">
                    <div class="flex w-full justify-between items-center h-auto  rounded-lg shadow-xs" :class="!desktopClass ? 'p-6 my-1 mb-1' : ''">
                        <div class="flex w-full" :class="!desktopClass ? 'mt-1' : 'pr-4'">
                            <span :class="desktopClass" class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-green-400 ">person</i>
                            </span>

                            <div class="ml-5 w-full pb-4">
                                <div class="text-base font-semibold text-gray-600" :class="!desktopClass ? 'pb-10 mt-1' : 'pb-4'">
                                     {{$t('customer_information')}}
                                </div>
                                <div class="text-sm font-light text-gray-500"></div>
                                <div class="w-full space-y-4">
                                    <div class="flex">
                                        <div
                                            class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="status" v-bind:style="{
                                                    borderColor: item.status?item.status.color:'',
                                                    }" class="bg-white text-gray-700 px-1">{{$t('status')}}
                                                        <span :class="$colors.required">*</span> 
                                                    </label>
                                                </p>
                                            </div>
                                            <p>
                                                <select name="status" autocomplete="type" :disabled="item.oldStatus && (item.oldStatus.name==='OutOfStock' || item.oldStatus.name==='Confirmed')" v-bind:style="{
                                                    color: item.status?item.status.color:'',
                                                    borderColor: item.status?item.status.color:'',}" v-model="item.status"
                                                    class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                    <option class="bg-white" selected :value="null">
                                                        {{$t('status')}}
                                                    </option>
                                                    <option class="bg-white text-gray-600"
                                                        v-for="(value, index) in statusOrder" :key="index"
                                                        :value="value.original">
                                                        {{$t(value.label)}}
                                                    </option>
                                                </select>

                                                <!-- Sous-status visible uniquement si le status principal est 'Cancelled' -->
                                                <div v-if="item.oldStatus && item.oldStatus.name === 'Cancelled' && !item.validated_status && currentUser.type !== 'TeleConsultant'" class="mt-2">
                                                    <div
                                                        class="border hover:border-green-500 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1"
                                                    >
                                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                            <label class="bg-white text-gray-700 px-1">
                                                            {{$t('Sous-status')}}
                                                            </label>
                                                        </p>
                                                        </div>

                                                        <p>
                                                        <select
                                                            v-model="item.subStatusCancelled"
                                                            class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white border rounded text-gray-700"
                                                        >
                                                            <option :value="null" disabled>{{$t('Sélectionner')}}</option>
                                                            <option value="pending">{{$t('En attente')}}</option>
                                                            <option value="done">{{$t('Terminé')}}</option>
                                                        </select>
                                                        </p>
                                                    </div>
                                                    <div v-if="item.subStatusCancelled && item.subStatusCancelled === 'pending'"
                                                        class="border hover:border-green-500 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1 mt-4"
                                                    >
                                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                            <label class="bg-white text-gray-700 px-1">
                                                            {{$t('TeleConsultant')}}
                                                            </label>
                                                        </p>
                                                        </div>

                                                        <p>
                                                            <v-select
                                                                label="fullName"
                                                                :options="teleConsultants"
                                                                v-model="item.teleConsultant"
                                                                :placeholder="$t('Select TeleConsultant')"
                                                                @search="searchUsers($event,'TeleConsultant')"
                                                                >
                                                            </v-select>
                                                        </p>
                                                    </div>
                                                </div>

                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="flex">
                                        <div
                                            class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="customerFullName"
                                                        class="bg-white text-gray-700 px-1">{{$t('full_name')}}
                                                        <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <input :id="'customerFullName' + index" autocomplete="false"
                                                    tabindex="0" type="text" v-model="item.customer.fullName"
                                                    class="py-2 text-xs px-2 outline-none block h-full w-full"
                                                    disabled />
                                            </p>
                                        </div>
                                    </div>

                                    <div
                                        class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerPhone" class="bg-white text-gray-700 px-1">{{$t('phone')}}
                                                    <span :class="$colors.required">*</span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <input :id="'customerPhone' + index" autocomplete="false" tabindex="0"
                                                type="text" v-model="item.customer.phone"
                                                class="py-2 text-xs px-2 outline-none block h-full w-full" disabled />
                                        </p>
                                    </div>
                                    <div :class="desktopClass"
                                        class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
                                        >
                                        <div
                                            class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                                        >
                                            <p>
                                            <label for="country" class="bg-white text-gray-700 px-1"
                                                >{{$t('country')}}</label
                                            >
                                            </p>
                                        </div>
                                        <p>
                                            <v-select
                                            
                                            v-model="item.customer.country"
                                            :options="options"
                                            v-bind:class="{ disabled: true }"
                                            label="name"
                                            >
                                            <template slot="option" slot-scope="option">
                                                <img
                                                class="flag-img"
                                                :src="$f.getCountryCode(option.code)"
                                                />
                                                {{ option.name }}
                                            </template>
                                            </v-select>
                                        </p>
                                    </div>

                                 <div class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                    <div
                                    class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                                    >
                                    <p>
                                        <label
                                        for="city"
                                        class="bg-white text-gray-700 px-1"
                                        >{{$t('city')}} <span :class="$colors.required">*</span></label
                                        >
                                    </p>
                                    </div>
                                    <p>
                                      <v-select  @input="setSelectedCity" v-model="item.customer.city" :options="cities" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed'" ></v-select>
                                    </p>
                                </div>

                                 <div :class="desktopClass" v-if="item.customer.city && feesShipp && item.customer.country == 'MA'" class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                        <p>
                                        <label
                                            for="Frais"
                                            
                                            class="bg-white text-gray-700 px-1"
                                            >{{$t('shipping_cost')}} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup>
                                        </label>
                                        </p>
                                    </div>
                                    <p>
                                        <input
                                        id="Frais"
                                        autocomplete="false"
                                        disabled
                                        tabindex="0"
                                        :value="feesShipp"
                                        type="text"
                                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                                        />
                                    </p>
                                    </div>
                                 <div
                                        class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerAddress" class="bg-white text-gray-700 px-1">{{$t('adress')}}
                                                    <span :class="$colors.required">*</span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <textarea :id="'customerAddress' + index" autocomplete="false" tabindex="0"
                                                type="text" v-model="item.customer.address" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed'"
                                                class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"
                                                ></textarea>
                                        </p>
                                    </div>
                                    <div v-if="desktopClass"
                                        class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerPhone" class="bg-white text-gray-700 px-1">{{$t('comment')}}
                                                    <span :class="$colors.required"></span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <textarea :id="'comment' + index" autocomplete="false" tabindex="0" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed'"
                                                type="text" v-model="item.comment"
                                                class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ****************************** Order Information *********************************************-->

                    <div :class="desktopClass" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-green-400 ">local_grocery_store</i>
                            </span>

                            <div class="ml-5 w-full">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                    {{$t('update_order_information')}}
                                </div>

                                <div class="w-full space-y-4">
                                    

                                    <div
                                        class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerPhone" class="bg-white text-gray-700 px-1">{{$t('shipping_address')}}
                                                    <span :class="$colors.required">*</span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <textarea v-if="item.oldStatus && item.oldStatus.name == 'Confirmed'"
                                                :id="'customerShippingAddress' + index" autocomplete="false"
                                                tabindex="0" type="text" v-model="item.customer.shippingAddress"
                                                class="py-2 text-xs px-2 outline-none block h-full w-full" disabled />

                                            <textarea v-else :id="'customerShippingAddress' + index"
                                                autocomplete="false" tabindex="0" type="text" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed'"
                                                v-model="item.customer.shippingAddress"
                                                class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                        </p>
                                    </div>

                                    <div
                                        class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                            <p>
                                                <label for="customerPhone" class="bg-white text-gray-700 px-1">{{$t('comment')}}
                                                    <span :class="$colors.required"></span></label>
                                            </p>
                                        </div>
                                        <p>
                                            <textarea :id="'comment' + index" autocomplete="false" tabindex="0" :disabled="item.oldStatus && item.oldStatus.name == 'Confirmed'"
                                                type="text" v-model="item.comment"
                                                class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
               
                <!--*******************  Product Order ***************************************-->
                <div :class="desktopClass"  class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                    <div class="flex w-full mt-1">
                        <span class="rounded-full h-12 w-12 bg-gray-200">
                            <i class="material-icons p-3 text-green-400 ">local_mall</i>
                        </span>

                        <div class="ml-5 w-full pb-4">
                            <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                 {{$t('order_products')}}
                            </div>

                            <div class="w-full space-y-4">
                                <div class="w-full">
                                    <table style="display: inline-table;"
                                        class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                                        <thead class="text-white">
                                            <tr
                                                class="bg-green-400  flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                <th class="p-2 justify-center">{{$t('products')}}</th>
                                                <th class="p-2 justify-center">{{$t('quantity')}}</th>
                                                <th class="p-2 justify-center">{{$t('total')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody class="flex-1 sm:flex-none" v-for="it in item.details" :key="it._id">
                                            <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                <td
                                                    class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                                                    <div class="flex space-x-10">
                                                        <div>
                                                            <img alt="..."
                                                                :src="it.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                                                                class="h-16 w-16 rounded-md mx-auto" />
                                                        </div>
                                                        <div>
                                                            {{ it.product.name }}
                                                            <p class="font-light">
                                                                {{$t('price')}} : {{ it.product.price }} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td
                                                    class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                    {{ it.quantity }}
                                                </td>
                                                <td
                                                    class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                    {{ it.quantity * it.product.price }} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <!--*******************  Order refondu ***************************************-->
                <div :class="desktopClass" v-if="item.status && item.status.name=='Return' && currentUser.type!='Seller'" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                    <div class="flex w-full mt-1">
                        <span class="rounded-full h-12 w-12 bg-gray-200">
                            <i class="material-icons p-3 text-green-400 ">replay</i>
                        </span>

                        <div class="ml-5 w-full pb-4">
                            <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                 {{$t('order_refunded_products')}}
                            </div>

                            <div class="w-full space-y-4">
                                <div class="w-full">
                                    <table style="display: inline-table;"
                                        class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                                        <thead class="text-white">
                                            <tr
                                                class="bg-green-400  flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                <th class="p-2 justify-center">{{$t('products')}}</th>
                                                <th class="p-2 justify-center"> {{$t('quantity')}}</th>
                                                <th class="p-2 justify-center"> {{$t('quantity_returned')}}</th>                                            
                                            </tr>
                                        </thead>
                                        <tbody class="flex-1 sm:flex-none" v-for="it in item.details" :key="it._id">
                                            <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                <td
                                                    class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                                                    <div class="flex space-x-10">
                                                        <div>
                                                            <img alt="..." :src="it.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                                                                class="h-16 w-16 rounded-md mx-auto" />
                                                        </div>
                                                        <div>
                                                            {{ it.product.name }}
                                                        </div>
                                                    </div>
                                                </td>
                                                 <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity }}</b></td>
                                                 <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                   
                                                    <div class="grid gap-4 " :class="CheckQteDefecteuseorderexist?'grid-cols-2':'grid-cols-1'">
                                                     <div class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-green-500  tracking-wider"><b>{{$t('ok_good')}}</b></div>
		                                        	 <div v-if="CheckQteDefecteuseorderexist" class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-green-500  tracking-wider"><b>{{$t('defective')}}</b></div>
                                                     <input v-model="it.product.qteChange" :disabled="CheckQteDefecteuseorderexist"  min="0" :max="it.quantity" type="number" class="border border-green-600  py-2 text-xs px-2 outline-none block h-full w-full">
                                                     <div v-if="CheckQteDefecteuseorderexist" class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity-it.product.qteChange }}</b></div>  
                                                    </div>
                                                 </td> 
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
</div>        
</template>
<script>
export default {
    props: {
            config: { required: true, type: Object},
            item:{ default: [] },
            shipping:{ type: Object ,  default: null },
            statusOrder:{ type: Array },
            zones:{ type: Array },
            cities:{ type: Array },
            courier:{ type: Array },
            index:{ type: Number },
            feesShipp:{ type: Number },
            idWharhouse:{ type: Object },
            currentUser: { type: Object },
            CheckQteDefecteuseorderexist:{required:false},  
            sous_warehouses: { type: Array,default() {return []}},
            desktopClass: { type: String, default: '' } ,
            teleConsultants: { type: Array,default() {return []}},
    },
    data() {
        return {
            typesShipp:["normal", "pendingChange", "change"],
            options: this.$countries,
            sous_warehouses_orders:[],
            // NEW: Price reduction response data
            priceReductionResponse: {
                comment: ''
            },
            processingPriceReduction: false
        }
     },
      watch:{
      'item.status'(val){
        if(val.name === 'Confirmed'){
             this.scrollTo(this.item._id);
             this.sous_warehouses_orders=[];
             if(this.sous_warehouses.length>0) this.getSousW();
             
        }
      }
    },
    async mounted() {
        this.shipping.order=this.item._id;
        // await this.CheckQteDefecteuseOrder();
    },
    methods: {  
        scrollTo(hash) {
            location.hash = "#order-" + hash;
        },  
        async getSousW() {
            for (let index = 0; index < this.item.details.length; index++) {
                const orderLine = this.item.details[index];
                const {content:product} = await this.$server.get("products",{  _id: orderLine.product._id||orderLine.product } );
                console.log('product------',product)
                let dataWhrahouse=this.$f.getElementInArrayByCountry(product.details,this.idWharhouse.country,orderLine.quantity,'manuelCreate');
                if(dataWhrahouse && dataWhrahouse.length>0){
                    this.sous_warehouses_orders=dataWhrahouse.map(i => i.warehouse);
                    this.item.sous_warehouses_orders=this.sous_warehouses_orders;
                }else this.sous_warehouses_orders=[] ;
                console.log('sous_warehouses_orders------',this.sous_warehouses_orders)
            }
        },  
        getCourierZone: function (val) {
            this.$emit('getCourierZone',val);
        },
        searchUsers: function (search,type) {
            this.$emit('searchUsers',search,type);
        },
        OrderChange: function () {
            this.$emit('OrderChange',this.index,this.item);
        },
        CheckQteDefecteuseOrder: function () {
            this.$emit('CheckQteDefecteuseOrder',this.item);
        },
        setSelectedCity: function (city) {
            if(city) this.$emit('getFeesShippBycity',city);
        },
        // NEW: Price reduction methods
        hasPendingPriceReduction() {
            return this.item.priceReduction && 
                   this.item.priceReduction.status === 'en attente' &&
                   this.currentUser.type != 'TeleConsultant' &&
                   this.item.status && this.item.status.name !== 'Confirmed';
        },

        async approvePriceReduction() {
            if (!confirm('Êtes-vous sûr de vouloir approuver cette réduction de prix ?')) {
                return;
            }

            this.processingPriceReduction = true;

            try {
                const response = await this.$server.update("orders", {
                    _id: this.item._id,
                    adminPriceReductionResponse: {
                        status: 'approuvé',
                        respondedAt: new Date(),
                        responseComment: this.priceReductionResponse.comment,
                        adminId: this.currentUser._id
                    }
                });

                console.log('response approvePriceReduction-----',response)

                if (response && response._id) {
                    // Update local item data
                    this.item.priceReduction.status = 'approuvé';
                    this.item.priceReduction.adminResponse = {
                        responseComment: this.priceReductionResponse.comment
                    };

                    // Update total price
                    this.item.totalPrice = this.item.priceReduction.proposedPrice;
                    const reductionRatio = this.item.priceReduction.proposedPrice / this.item.totalPrice;
                    this.item.details.forEach(detail => {
                        detail.unitPrice = Math.round(detail.unitPrice * reductionRatio * 100) / 100;
                    });

                    this.$alert('Réduction de prix approuvée avec succès!', 'success');
                    this.priceReductionResponse.comment = '';
                    
                    // Emit event to parent to refresh data
                    this.$emit('priceReductionProcessed', {
                        orderId: this.item._id,
                        status: 'approuvé',
                        newPrice: this.item.priceReduction.proposedPrice
                    });
                } else {
                    throw new Error(response.message || 'Erreur lors de l\'approbation');
                }
            } catch (error) {
                console.error('Error approving price reduction:', error);
                this.$alert('Erreur lors de l\'approbation de la réduction', 'error');
            } finally {
                this.processingPriceReduction = false;
            }
        },

        async rejectPriceReduction() {
            if (!this.priceReductionResponse.comment.trim()) {
                this.$alert('Veuillez saisir un commentaire expliquant le refus', 'warning');
                return;
            }

            if (!confirm('Êtes-vous sûr de vouloir refuser cette réduction de prix ?')) {
                return;
            }

            this.processingPriceReduction = true;

            try {
                const response = await this.$server.update("orders", {
                    _id: this.item._id,
                    adminPriceReductionResponse: {
                        status: 'rejeté',
                        responseComment: this.priceReductionResponse.comment,
                    }
                });

                if (response && response._id) {
                    // Update local item data
                    this.item.priceReduction.status = 'rejeté';
                    this.item.priceReduction.adminResponse = {
                        admin: this.currentUser._id,
                        respondedAt: new Date(),
                        responseComment: this.priceReductionResponse.comment
                    };

                    this.$alert('Réduction de prix refusée', 'info');
                    this.priceReductionResponse.comment = '';
                    
                    // Emit event to parent
                    this.$emit('priceReductionProcessed', {
                        orderId: this.item._id,
                        status: 'rejeté',
                        reason: this.priceReductionResponse.comment
                    });
                } else {
                    throw new Error(response.message || 'Erreur lors du refus');
                }
            } catch (error) {
                console.error('Error rejecting price reduction:', error);
                this.$alert('Erreur lors du refus de la réduction', 'error');
            } finally {
                this.processingPriceReduction = false;
            }
        }
    }    
}
</script>